import React from 'react';
import { SPACING_SECTION, SPACING_BUTTON } from '../constants/layout';

export default function Loading({ message = "Loading…" }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'var(--bg-color, #ffffff)',
      zIndex: 100
    }}>
      <div style={{
        width: '40px',
        height: '40px',
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #B57EDC',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }}></div>
      <p style={{
        padding: `${SPACING_SECTION} ${SPACING_BUTTON}`,
        fontSize: '14px',
        color: '#666',
        margin: `${SPACING_BUTTON} 0 0 0`
      }}>
        {message}
      </p>
      
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
